const defaultShipment = {
  address_from: null,
  address_to: null,

  pickup_date_from: undefined,
  pickup_date_to: undefined,
  pickup_time_from: undefined,
  pickup_time_to: undefined,

  dropoff_date_from: undefined,
  dropoff_date_to: undefined,
  dropoff_time_from: undefined,
  dropoff_time_to: undefined,

  extras: [],
  numLoads: 0,
  loads: [],
  internal_reference: false,
  pickup_comment_from_shipper_to_driver: false,
  dropoff_comment_from_shipper_to_driver: false,
};

const initialState = {
  FIRST_SHIPMENT: {
    ...defaultShipment,
    shipmentKey: 'FIRST_SHIPMENT',
    loads: ['FIRST'],
  },
  FIRST_SHIPMENT_RECURRING: {
    ...defaultShipment,
    shipmentKey: 'FIRST_SHIPMENT_RECURRING',
    loads: ['FIRST_LOAD_RECURRING'],
  },
  MR_DISTRIBUTION_FIRST_SHIPMENT: {
    ...defaultShipment,
    shipmentKey: 'MR_DISTRIBUTION_FIRST_SHIPMENT',
    loads: [],
  },
  MR_DISTRIBUTION_SECOND_SHIPMENT: {
    ...defaultShipment,
    shipmentKey: 'MR_DISTRIBUTION_SECOND_SHIPMENT',
    loads: [],
  },
  MR_COLLECTION_FIRST_SHIPMENT: {
    ...defaultShipment,
    shipmentKey: 'MR_COLLECTION_FIRST_SHIPMENT',
    loads: [],
  },
  MR_COLLECTION_SECOND_SHIPMENT: {
    ...defaultShipment,
    shipmentKey: 'MR_COLLECTION_SECOND_SHIPMENT',
    loads: [],
  },
};

const initialStateForTest = {
  FIRST_SHIPMENT: {
    ...defaultShipment,
    loads: ['FIRST', 'SECOND'],
    shipmentKey: 'FIRST_SHIPMENT',
  },
  FIRST_SHIPMENT_RECURRING: {
    ...defaultShipment,
    shipmentKey: 'FIRST_SHIPMENT_RECURRING',
    loads: [],
  },
  MR_DISTRIBUTION_FIRST_SHIPMENT: {
    ...defaultShipment,
    shipmentKey: 'MR_DISTRIBUTION_FIRST_SHIPMENT',
    loads: [],
  },
  MR_DISTRIBUTION_SECOND_SHIPMENT: {
    ...defaultShipment,
    shipmentKey: 'MR_DISTRIBUTION_SECOND_SHIPMENT',
    loads: [],
  },
  MR_COLLECTION_FIRST_SHIPMENT: {
    ...defaultShipment,
    shipmentKey: 'MR_COLLECTION_FIRST_SHIPMENT',
    loads: [],
  },
  MR_COLLECTION_SECOND_SHIPMENT: {
    ...defaultShipment,
    shipmentKey: 'MR_COLLECTION_SECOND_SHIPMENT',
    loads: [],
  },
};

export default initialState;
export { defaultShipment, initialStateForTest };
